/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListSupportTicketsQueryResponse, ListSupportTicketsQueryParams, ListSupportTickets400, ListSupportTickets401, ListSupportTickets403, ListSupportTickets404, ListSupportTickets409, ListSupportTickets500 } from "../../types/supportController/ListSupportTickets.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListSupportTicketsUrl() {
  const res = { method: 'GET', url: `/api/support/tickets/` as const }
  return res
}

/**
 * @summary List support tickets
 * {@link /api/support/tickets/}
 */
export async function listSupportTickets(params?: ListSupportTicketsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListSupportTicketsQueryResponse, ResponseErrorConfig<ListSupportTickets400 | ListSupportTickets401 | ListSupportTickets403 | ListSupportTickets404 | ListSupportTickets409 | ListSupportTickets500>, unknown>({ method : "GET", url : getListSupportTicketsUrl().url.toString(), params, ... requestConfig })
  return res.data
}